import axios from 'axios';

export const getTokens = <T>(code: string) => axios.post<T>('/google-auth/', { code });

export const refreshTokens = <T>(refreshToken: string) =>
  axios.post<T>('/google-auth/refresh-token/', { refreshToken });
